// extracted by mini-css-extract-plugin
export default {"form-content":"CarouselForm_form-content__PNlNK","imageCont":"CarouselForm_imageCont__LTmeg","image":"CarouselForm_image__5bLEK","content-image":"CarouselForm_content-image__a5DVI"};